// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-35fb31a6]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#c41230;redBright:#eb1700}#countdown-seconds[data-v-35fb31a6]{display:inline-block;width:1.35em;text-align:right}", ""]);
// Exports
module.exports = exports;
